// src/components/admin/tabs/PointsCenterTab.jsx
// 积分中心外壳：5 个子 tab —— 总览 / 排行与明细 / 项目核算 / 限额策略 / 发放与计划。
// 「发放与计划」原样收编现有 PointsTab。
import React, { useState } from "react";
import { BarChart3, CalendarClock, ClipboardList, LayoutDashboard, ShieldCheck } from "lucide-react";
import PointsTab from "./PointsTab";
import PointsOverviewPane from "./pointsCenter/PointsOverviewPane";
import PointsRankingPane from "./pointsCenter/PointsRankingPane";
import PointsSettlementPane from "./pointsCenter/PointsSettlementPane";
import PointsPolicyPane from "./pointsCenter/PointsPolicyPane";

const SUB_TABS = [
  { key: "overview", label: "总览", icon: LayoutDashboard, Comp: PointsOverviewPane },
  { key: "ranking", label: "排行与明细", icon: BarChart3, Comp: PointsRankingPane },
  { key: "settlement", label: "项目核算", icon: ClipboardList, Comp: PointsSettlementPane },
  { key: "policies", label: "限额策略", icon: ShieldCheck, Comp: PointsPolicyPane },
  { key: "grants", label: "发放与计划", icon: CalendarClock, Comp: PointsTab },
];

const PointsCenterTab = ({ projectOptions = [] }) => {
  const [active, setActive] = useState("overview");
  const ActiveComp = SUB_TABS.find((t) => t.key === active)?.Comp || SUB_TABS[0].Comp;

  return (
    <div>
      <div className="flex gap-1 mb-4 border-b overflow-x-auto" style={{ borderColor: "var(--color-border-secondary)" }}>
        {SUB_TABS.map((t) => {
          const Icon = t.icon;
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setActive(t.key)}
              className="px-3 py-2 text-xs flex items-center gap-1.5 transition-colors duration-150 shrink-0 cursor-pointer"
              style={{
                borderBottom: isActive ? "2px solid var(--color-warning)" : "2px solid transparent",
                color: isActive ? "var(--color-text-primary)" : "var(--color-text-muted)",
                fontWeight: isActive ? 600 : 400,
              }}
            >
              <Icon size={12} style={isActive ? { color: "var(--color-warning)" } : undefined} />
              {t.label}
            </button>
          );
        })}
      </div>
      <div key={active} className="animate-in fade-in duration-150">
        <ActiveComp projectOptions={projectOptions} />
      </div>
    </div>
  );
};

export default PointsCenterTab;
